<template>
  <a-popover :trigger="trigger" :visible="optionsVisible" @visibleChange="handleClickChange">
    <template slot="content">
      <slot name="content"></slot>
    </template>
    <span style="user-select: none;" :style="{color:scolor}">{{title}}</span>
  </a-popover>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "‧‧‧",
    },
    trigger: {
      default: "hover",
      type: String,
    },
    scolor:{
      default: "#f2f2f2",
      type: String,
    }
    // visible: {
    //   type: Boolean,
    //   required: true,
    // },
    // targetData: {
    //   type: Object,
    //   required: true,
    // },
    // options: {
    //   type: Array,
    //   required: true,
    // },
  },
  // computed: {
  //   optionsVisible: {
  //     get: function () {
  //       return this.visible;
  //     },
  //     set: function () {},
  //   },
  // },
  // watch: {
  //   visible: function (value) {
  //     this.optionsVisible =  value
  //     console.log(visible, this.optionsVisible);
  //   }
  // },
  data() {
    return {
      optionsVisible: false,
    };
  },
  methods: {
    handleClickChange(visible) {
      this.optionsVisible = visible;
    },
    // close() {
    //   this.optionsVisible = false;
    // },
  },
  mounted(){
    // console.log("+++++++++++++",this.scolor);
  }
};
</script>

<style lang="scss" scoped>
</style>